import { usePageTitle } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'

import { MeetingIntelligenceUserSettings } from 'features/meeting_intelligence'

export const MeetingIntelligencePage = () => {
  usePageTitle(`${I18n.t('publisher.account_settings.navigation.meeting_intelligence')} - ${I18n.t('publisher.personal_settings.title')}`)

  return (
    <MeetingIntelligenceUserSettings />
  )
}
